<template>
  <div
    id="addModal"
    class="modal fade bd-example-modal-xl"
    tabindex="-1"
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Roles</h5>
          <button
            class="btn-close"
            type="button"
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div>
            <b>USUARIO: </b>
            {{ user?.name }} {{ user?.first_last_name }}
            {{ user?.second_last_name }}
          </div>
          <div class="card-body row switch-showcase">
            <div class="col-sm-12">
              <div v-for="role in roles" :key="role.id" class="media">
                <label class="col-form-label m-r-10">{{ role.name }}</label>
                <div class="media-body text-end icon-state switch-outline">
                  <label class="switch">
                    <input
                      type="checkbox"
                      @change="(event) => updateRol(role, event)"
                      :checked="selectedRoles(role)"
                    />
                    <span class="switch-state bg-primary"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from "vue";
import axios from "@/includes/connection"; // Ensure axios is imported

const props = defineProps({ user: Object, roles: Array, userRoles: Array });
const emits = defineEmits(["closeModal"]);
const swal = inject("$swal");

const user = computed(() => props.user);
const roles = computed(() => props.roles);
const userRoles = computed(() => props.userRoles);

const selectedRoles = (role) => {
  // Ensure that the role ID is correctly compared with userRoles

  return userRoles.value.some((userRole) => {
    return userRole.id === role.id;
  });
};

function closeModal() {
  emits("closeModal");
}

const updateRol = async (role, event) => {
  const info = {
    user_id: user.value.id,
    rol_id: role.id,
    state: event.target.checked, // Use the checked property to set the state
  };
  console.log("info: ", info);
  try {
    const response = await axios.post("/rol", info);
    console.log(response.data);
  } catch (error) {
    console.error(error);
  }
};
</script>
